import React from "react";
import { logEvent, logInteractionEvent } from "../../utils/appInsight";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { trackAdobeAppClick, trackAdobeClick } from "../../utils/adobeLogging";

const FooterButtons = ({ topicData, color, downloadLabel }) => {
  const lang = useSelector((state) => state.ui.lang);
  const section = useSelector((state) => state.progress.section);
  const { t } = useTranslation();

  if (!downloadLabel) {
    downloadLabel = t("downloadTemplate");
  }

  return (
    <div className="row flex justify-center sm:-mx-35">
      {topicData.template.hasTemplate && (
        <a
          onClick={() => {
            trackAdobeAppClick({ action: "download-template", language:lang });
            trackAdobeClick(
              { fileName: topicData.template.title, fileLanguage: lang },
              {
                linkTitle: downloadLabel,
                linkModule: `${section}-module-page`,
                targetURL: topicData.template.fileUrl,
              },
              false
            );
            logEvent({
              name: "TemplateDownloaded",
              properties: {
                section,
                template: topicData.template,
              },
            });
            logInteractionEvent("TemplateDownloaded", {
              section,
              template: topicData.template.fileUrl,
            });
          }}
          href={topicData.template.fileUrl}
          target="_blank"
          download={topicData.template.fileUrl}
          rel="noopener noreferrer"
          className={`bg-${color} content-footer-button btn-lg btn-download flex p-10 sm:py-5 uppercase text-white hover:bg-gray-900 hover:text-white font-secondary font-bold mx-5 mb-5`}
        >
          <strong className="flex items-center font-bold">
            <span className="flex-grow">{downloadLabel}</span>
            <span className="icon-download ml-5"></span>
          </strong>
        </a>
      )}
    </div>
  );
};

export default FooterButtons;
